import { Base } from "ui/Scripts/source/framework/base";
import { CompanyListItem, ICompanyListItem } from "../company/companyListItem";
import { IUnitNode, UnitNode } from "../unit/unitNode";
import { IUnitPermissionUserGroup, UnitPermissionUserGroup } from "../userGroup/unitPermissionUserGroup";
import { TUnitPermission } from "./unitPermission";

export interface IUnitNodePermissions {
    userGroups: IUnitPermissionUserGroup[];
    unitNode: IUnitNode;
    partnerCompanies: ICompanyListItem[];
    unitPermissions: TUnitPermission[];
}

export class UnitNodePermissions implements IUnitNodePermissions {
    userGroups: UnitPermissionUserGroup[];
    unitNode: UnitNode;
    partnerCompanies: CompanyListItem[];
    unitPermissions: TUnitPermission[];

    constructor();
    constructor(obj: IUnitNodePermissions);
    constructor(obj?: any) {
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, UnitPermissionUserGroup);
        this.unitNode = new UnitNode(obj && obj.unitNode ? obj.unitNode : null);
        this.partnerCompanies = Base.getTypedArray(obj ? obj.partnerCompanies : null, CompanyListItem);
        this.unitPermissions = obj && obj.unitPermissions || [];
    }
}